module.exports = __webpack_public_path__ + "img/1463109375.45db8d69.jpg";